import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const GA_MEASUREMENT_ID = 'G-XNDE1Q508Y';

const chargerGoogleAnalytics = () => {
  if (window.gtag) return;

  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  script.async = true;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID, {
    anonymize_ip: true,
  });
};

const BanniereCookie = () => {
  const navigate = useNavigate();
  const [estVisible, setEstVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (consent === 'accepted') {
      chargerGoogleAnalytics();
    } else if (!consent) {
      setEstVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    chargerGoogleAnalytics();
    setEstVisible(false);
  };

  const handleRefuse = () => {
    localStorage.setItem('cookieConsent', 'refused');
    setEstVisible(false);
  };

  if (!estVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9999] p-4 sm:p-6 bg-gris-clair dark:bg-gris-sombre border-t-4 border-bleu-je shadow-2xl transition-all">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        
        <div className="text-left flex-1 space-y-1">
          <p className="font-bold text-bleu-sombre dark:text-blanc-sombre text-base">
            À propos de vos cookies 🍪
          </p>
          <p className="text-sm text-gris-sombre dark:text-blanc-sombre leading-relaxed">
            Nous respectons votre vie privée : aucun cookie publicitaire n'est utilisé. 
            Nous utilisons uniquement des cookies de mesure d'audience (Google Analytics) et un cookie fonctionnel pour mémoriser votre préférence d'affichage (mode clair ou sombre).{' '}
            <button 
              onClick={() => { navigate('/politique-de-confidentialite'); window.scrollTo(0, 0); }} 
              className="text-bleu-je hover:text-bleu-sombre dark:hover:text-bleu-gris underline inline font-medium transition-colors"
            >
              En savoir plus
            </button>
          </p>
        </div>

        <div className="flex items-center gap-3 shrink-0 w-full md:w-auto justify-end">
          <button 
            onClick={handleRefuse} 
            className="bg-blanc-sombre hover:bg-bleu-gris hover:text-gris-clair text-gris-sombre transition-colors px-5 py-2.5 rounded-lg font-medium text-sm w-full md:w-auto text-center"
          >
            Refuser
          </button>
          <button 
            onClick={handleAccept} 
            className="bg-bleu-footer hover:bg-bleu-je text-gris-clair transition-colors px-6 py-2.5 rounded-lg font-medium text-sm shadow-md w-full md:w-auto text-center"
          >
            Accepter
          </button>
        </div>

      </div>
    </div>
  );
};

export default BanniereCookie;